import medicalMathThumbnail from "../../assets/medical-math-thumbnail.png";
import unfamiliarCaseThumbnail from "../../assets/unfamiliar-case-thumbnail.png";

// Source-of-truth for the /use-cases index. Newest first.
//
// Each entry is tagged with a list of WORKFLOW types (not animal type or
// specialty). The same case can appear under multiple workflow tags so when
// we add the filter bar (~5+ cases) it shows up everywhere it's relevant.

export type WorkflowTag =
  | "Differentials"
  | "Client comms"
  | "Handouts"
  | "Referrals"
  | "Templates"
  | "History review"
  | "Research"
  | "Documentation"
  | "Calculations"
  | "Treatment plans";

export type UseCase = {
  id: string;
  /** Path to the use-case detail page. */
  href: string;
  /** Headline shown on the card. */
  headline: string;
  /** 1-2 sentence story hook. */
  description: string;
  /** Optional cover thumbnail. Renders at the top of the card. */
  thumbnailSrc?: string;
  /** Optional alt text for the thumbnail. Defaults to the headline. */
  thumbnailAlt?: string;
  /** Workflow types this case demonstrates. Drives the future filter bar. */
  workflowTags: WorkflowTag[];
  /** ISO date — used for sort (newest first on the index). */
  date: string;
};

export const USE_CASES: UseCase[] = [
  {
    id: "dose-calculations-within-companion",
    href: "/use-cases/dose-calculations-within-companion",
    headline:
      "Dose Calculations, Fluid Math, Treatment Plans — All Within Companion",
    description:
      "Watch how one vet used Companion to build a full V/D treatment plan and calculate a gabapentin course, all from one conversation with Companion.",
    thumbnailSrc: medicalMathThumbnail,
    thumbnailAlt:
      "Medical Math — vet, dog, calculator, and dose-rate formulas with Companion",
    workflowTags: ["Calculations", "Treatment plans"],
    date: "2026-05-07",
  },
  {
    id: "unfamiliar-case-from-intake-to-referral",
    href: "/use-cases/how-companion-supports-an-unfamiliar-case-from-intake-to-referral",
    headline:
      "How Companion Supports an Unfamiliar Case from Intake to Referral 🦔✨",
    description:
      "When an unfamiliar case lands on the schedule, Companion turns one conversation into the differentials, plan, handout, and referral letter you need to see it through.",
    thumbnailSrc: unfamiliarCaseThumbnail,
    thumbnailAlt:
      "Companion handling an unfamiliar veterinary case from intake to referral",
    workflowTags: ["Differentials", "Client comms", "Handouts", "Referrals"],
    date: "2026-05-05",
  },
];
